import FilterIcon from '@common/assets/icons/filter.svg?react';
import {
  IconButton,
  type IconButtonProps,
} from '@common/ui/buttons/IconButton';
import { Indicator } from '@common/ui/Indicator';

export interface FiltersButtonProps extends Omit<IconButtonProps, 'testId'> {
  filtersCount?: number;
}

export const FiltersButton = ({
  filtersCount,
  ...props
}: FiltersButtonProps) => {
  return (
    <IconButton
      testId="filters-button"
      size={400}
      variant="actionPrimary"
      {...props}
    >
      <Indicator
        value={filtersCount}
        style={{
          top: -8,
          right: -8,
        }}
      >
        <FilterIcon />
      </Indicator>
    </IconButton>
  );
};
